import payment from './RU/payment';




export default {
  ...payment
};
